import {useAppSelector} from "../../store/hooks";
import {ISearchFormValues} from "../types/ISearchFormValues";
import {useRecentFilters} from "./use_recent_filters";

/**
 * Shared hook for recent filters display used by
 * RecentFiltersRegions and RecentFiltersSidebar.
 */
export const useRecentFiltersDisplay = () => {
    const {recentFilters, latestQuery, shouldShow} = useRecentFilters();
    const currentFormValues = useAppSelector((state) => state.search.formValues) as ISearchFormValues;

    return {
        recentFilters,
        latestQuery,
        shouldShow,
        currentFormValues
    };
};
import {useAppSelector} from "../../store/hooks";
import {ISearchFormValues} from "../types/ISearchFormValues";
import {useRecentFilters} from "./use_recent_filters";

/**
 * Shared hook for recent filters display used by
 * RecentFiltersRegions and RecentFiltersSidebar.
 */
export const useRecentFiltersDisplay = () => {
    const {recentFilters, latestQuery, shouldShow} = useRecentFilters();
    const currentFormValues = useAppSelector((state) => state.search.formValues) as ISearchFormValues;

    return {
        recentFilters,
        latestQuery,
        shouldShow,
        currentFormValues
    };
};
